module.exports = __webpack_public_path__ + "img/sand-dune-decal-00.b180f37f.png";